export enum ROLES {
  ADMIN = 'ADMIN',
  ASSISTANT = 'ASSISTANT',
  GUARDIAN = 'GUARDIAN',
  TEACHER = 'TEACHER',
  STUDENT = 'STUDENT'
}

export enum ENROLLMENT_STATUS {
  REQUESTED = 'SOLICITADO',
  APPROVED = 'APROBADO',
  REJECTED = 'RECHAZADO',
}

export enum DOCUMENT_TYPES {
  DNI = 'DNI',
  CE = 'Carnet de Extranjería',
  PASSPORT = 'Pasaporte',
}
